import Vue from 'vue';
import NuxtJsonld from 'nuxt-jsonld';

// NOTE: better import wehere its needed instead of using as a plugin
Vue.use(NuxtJsonld);
